import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

const useAsyncReducer = (reducer, initialState = null) => {
  const [state, setState] = useState(initialState);

  const dispatch = async (action) => {
    const result = reducer(state, action);
    if (typeof result.then === 'function') {
      try {
        const newState = await result;
        setState(newState);
      } catch (err) {
        setState({ ...state, error: err });
      }
    } else {
      setState(result);
    }
  };

  return [state, dispatch];
};

const createDataContext = (reducer, actions, initialState) => {
  const Context = createContext({});
  const Provider = ({ children }) => {
    const [state, dispatch] = useAsyncReducer(reducer, initialState);

    const boundActions = {};

    Object.entries(actions).forEach((action) => {
      const [key, value] = action;
      boundActions[key] = value(dispatch);
    });

    return (
      <Context.Provider value={{ actions: { ...boundActions }, state }}>
        {children}
      </Context.Provider>
    );
  };

  Provider.propTypes = {
    children: PropTypes.node.isRequired,
  };

  return { Context, Provider };
};

export default createDataContext;
